'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var classnames = require('classnames');
var styleInject_es = require('../style-inject.es-9d2f5f4e.js');
var useAssert = require('@jobber/hooks/useAssert');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var css_248z$2 = ".YJHtDDKq6WI- {\n  grid-column: initial;\n  grid-column-end: span var(--gridCell--size-xs);\n}@media (min-width: 490px) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-sm);\n}\n  }@media (--small-screens-and-up) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-sm);\n}\n  }@media (min-width: 768px) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-md);\n}\n  }@media (--medium-screens-and-up) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-md);\n}\n  }@media (min-width: 1080px) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-lg);\n}\n  }@media (--large-screens-and-up) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-lg);\n}\n  }@media (min-width: 1440px) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-xl);\n}\n  }@media (--extra-large-screens-and-up) {.YJHtDDKq6WI- {\n    grid-column-end: span var(--gridCell--size-xl);\n}\n  }\n";
var styles$1 = {"gridCell":"YJHtDDKq6WI-"};
styleInject_es.styleInject(css_248z$2);

/**
 * Breakpoints that we support
 */
const breakpoints = ["xs", "sm", "md", "lg", "xl"];
const MAX_COLUMNS = 12;
const GRID_CELL_TEST_ID = "ATL-Grid-GridCell";
function InternalGridCell({ size, children, }) {
    /**
     * Build CSS variables for column sizes for all possible breakpoints to size
     * the column
     */
    const cssSizeVariables = breakpoints.reduce(getSizeCSSVariables(size), {});
    return (React__default["default"].createElement("div", { "data-testid": GRID_CELL_TEST_ID, className: styles$1.gridCell, style: cssSizeVariables }, children));
}
function getSizeCSSVariables(size) {
    return (breakpointsObj, currentSize) => {
        let columnSize = size[currentSize];
        // If a column size isn't provided in the size prop, use the previous
        // breakpoint's value
        if (!columnSize) {
            const existingValues = Object.values(breakpointsObj);
            const lastKnownValue = existingValues[existingValues.length - 1];
            columnSize = lastKnownValue || MAX_COLUMNS;
        }
        breakpointsObj[`--gridCell--size-${currentSize}`] = columnSize;
        return breakpointsObj;
    };
}

var css_248z$1 = ".NqFGJV-UF3Q- {\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.IZLiiSquUTM- {\n  gap: calc(16px * 1);\n  gap: var(--space-base);\n}\n\n@media (min-width: 768px) {\n  .IZLiiSquUTM- {\n    gap: calc(16px * 1.5);\n    gap: var(--space-large);\n  }\n}\n\n@media (--medium-screens-and-up) {\n  .IZLiiSquUTM- {\n    gap: calc(16px * 1.5);\n    gap: var(--space-large);\n  }\n}\n";
var styles = {"grid":"NqFGJV-UF3Q-","gap":"IZLiiSquUTM-"};
styleInject_es.styleInject(css_248z$1);

var css_248z = "._8XlrWg3FV-Q- {\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.uKzqJPlYxJs- {\n  -ms-flex-align: start;\n      align-items: start;\n}\n\n.CSBjeFlj2xQ- {\n  -ms-flex-align: end;\n      align-items: end;\n}\n\n.BYyFdzONXyk- {\n  -ms-flex-align: stretch;\n      align-items: stretch;\n}\n";
var alignments = {"center":"_8XlrWg3FV-Q-","start":"uKzqJPlYxJs-","end":"CSBjeFlj2xQ-","stretch":"BYyFdzONXyk-"};
styleInject_es.styleInject(css_248z);

// Only need the component to pass in the data as a react children
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function GridCell(props) {
    // Throw error when <Grid.Cell /> gets used outside of the <Grid />
    useAssert.useAssert(true, "`<Grid.Cell>` can only be used inside of a `<Grid>` component!");
    return React__default["default"].createElement(React__default["default"].Fragment, null);
}

const GRID_TEST_ID = "ATL-Grid";
function Grid({ alignItems = "start", gap = true, children, }) {
    const classnames = classnames__default["default"](styles.grid, alignments[alignItems], {
        [styles.gap]: gap,
    });
    return (React__default["default"].createElement("div", { "data-testid": GRID_TEST_ID, className: classnames }, React__default["default"].Children.map(children, ({ props }) => {
        return React__default["default"].createElement(InternalGridCell, Object.assign({}, props));
    })));
}
Grid.Cell = GridCell;

exports.GRID_TEST_ID = GRID_TEST_ID;
exports.Grid = Grid;
